// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__w6LAv","validationTips":"StatementDescriptor_validationTips__2yk9R"};